import { useState, useCallback } from "react";

export function useSessionStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = sessionStorage.getItem(key);
      if (item !== null) {
        const parsed = JSON.parse(item);
        // If initialValue is an array, ensure parsed value is also an array
        if (Array.isArray(initialValue) && !Array.isArray(parsed)) {
          return initialValue;
        }
        return parsed;
      }
      return initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value) => {
      setStoredValue((prev) => {
        const next = typeof value === "function" ? value(prev) : value;
        try {
          sessionStorage.setItem(key, JSON.stringify(next));
        } catch (e) {
          console.error(`Failed to save "${key}" to sessionStorage:`, e);
        }
        return next;
      });
    },
    [key]
  );

  return [storedValue, setValue];
}
